import { sectionNames } from "@saleor/intl";
import React from "react";
import { useIntl } from "react-intl";
import { Route, Routes, useParams } from "react-router-dom";

import { WindowTitle } from "../components/WindowTitle";
import CountryList from "./views/CountryList";
import CountryTaxesComponent from "./views/CountryTaxes";

const CountryTaxes: React.FC = () => {
  const { code } = useParams();
  return <CountryTaxesComponent code={code} />;
};

const Component = () => {
  const intl = useIntl();

  return (
    <>
      <WindowTitle title={intl.formatMessage(sectionNames.taxes)} />
      <Routes>
        <Route path={""} element={<CountryList />} />
        <Route path={":code"} element={<CountryTaxes />} />
      </Routes>
    </>
  );
};

export default Component;
